import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import RolesPermissionsDrawer from '@/pages/rolesPermissionsAdmin/RolesPermissionsAdminDrawer.component'
import { createRoleIdQueryOptions } from '@/services/rolesPermissions/rolesPermission.options'
import { createAttachmentTypesByCustomerQueryOptions } from '@/hooks/fetches/useTicket.service'

export const Route = createFileRoute('/_auth/permissions/$roleId')({
  component: () => <RolesPermissionsDrawer />,
  params: {
    parse: (params) => ({
      roleId: z.number().int().parse(Number(params.roleId)),
    }),
    stringify: ({ roleId }) => ({ roleId: `${roleId}` }),
  },
  validateSearch: (search) => {
    return z
      .object({
        variant: z.enum(['edit', 'new']).default('edit'),
      })
      .parse(search)
  },
  loader: async ({ params, context }) => {
    const role = context.queryClient.ensureQueryData(createRoleIdQueryOptions(params.roleId))
    return {
      role,
    }
  },
})
